const dealersRootState = {
    parent: 'root',
    url: '/dealers',
    abstract: true,
    template: '<ui-view></ui-view>'
};

const dealersListState = {
    url: '',
    controllerAs: 'vmcAccountList',
    template: require('./controllers/list/vmcAccountList.html'),
    controller: require('./controllers/list/vmcAccountListCtrl')
};

const franchiseAndEnquiryDetailsState = {
    url: '/franchiseAndEnquiryDetails/:vmcAccountId',
    controllerAs: 'franchiseAndEnquiryDetails',
    template: require('./controllers/franchiseAndEnquiryDetails/franchiseAndEnquiryDetails.html'),
    controller: require('./controllers/franchiseAndEnquiryDetails/franchiseAndEnquiryDetailsCtrl')
};

export default function (app) {
    app.config(($stateProvider, userRolesObject) => {
        dealersRootState.data = {
            roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.accountAdmin, userRolesObject.teamLead]
        };

        $stateProvider
            .state('dealers', dealersRootState)
            .state('dealers.list', dealersListState)
            .state('dealers.franchiseAndEnquiryDetails', franchiseAndEnquiryDetailsState);
    });
}



// WEBPACK FOOTER //
// ./Client/app/dealer/routes.js